export default __webpack_public_path__ + "media/images/favicon/favicon-32-35fb6cd1fed3c601af3eec3f89f4fc99.png";